import api from '~/services/api';
import PropTypes from 'prop-types';

const endPoint = 'extrarevenues';

// GET
export const getExtraRevenues = async (params) => {
  try {
    const { data } = await api.get(`/${endPoint}`, params);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// CREATE
export const createExtraRevenues = async (values) => {
  try {
    const { data } = await api.post(`/${endPoint}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// UPDATE
export const updateExtraRevenues = async (id, values) => {
  try {
    const { data } = await api.put(`/${endPoint}/${id}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// DELETE
export const deleteExtraRevenues = async (id) => {
  try {
    const { data } = await api.delete(`/${endPoint}/${id}`);
    return data.data;
  } catch (error) {
    throw error;
  }
};

getExtraRevenues.propTypes = {
  params: PropTypes.object.isRequired,
};

createExtraRevenues.propTypes = {
  values: PropTypes.object.isRequired,
};

updateExtraRevenues.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteExtraRevenues.propTypes = {
  id: PropTypes.string.isRequired,
};
